import React, {Component} from 'react';
import Ionicon from 'react-ionicons'

import './Home.css';

class Home extends Component {

    render() {
        return (

            <div className='content-wrapper'>
                <div className='top'>
                    <div className='top-left'>
                    </div>
                    <div className='top-right'>
                        <h1>PAT HANN</h1>
                        <div className='contact-info'>pathann@gmail.com</div>
                        <div className='contact-info'>+44 7714 489991</div>

                        <div className='icon-wrapper'>
                            <a href="https://www.linkedin.com/in/pathann/" target="new"><Ionicon icon='logo-linkedin' fontSize='35px' color='#37474F' alt='View Pat on Linked In'/></a>
                        </div>
                        <div className='icon-wrapper'>
                            <a href="patrick-hann-cv-2018.pdf" target="new"><img className='cv-icon' src='images/cv-icon.svg' alt='View CV'/></a>
                        </div>
                    </div>
                </div>
                <div className='bottom'>
                    <div className='bottom-section'>
                        <div className='quote'>
                            "I am a software developer in London."
                        </div>
                    </div>
                    <div className='bottom-section'>
                        <div className='quote'>
                            "Technology is my passion."
                        </div>
                    </div>
                    <div className='bottom-section'>
                        <div className='quote'>
                            "Ideas are the first step to improve the world."
                        </div>
                    </div>
                </div>


            </div>

        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js